import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getDocumentByUid } from 'helpers/Prismic';
import Loader from 'components/Loader';
import Error from 'components/Error';
import globalProps from 'utils/globalProps';
import FAQHubBanner from 'containers/FAQHub/FAQHubBanner';
import FAQHubNavigation from 'containers/FAQHub/FAQHubNavigation';
import KnowledgeHubFAQs from 'containers/KnowledgeHub/KnowledgeHubFAQs';
import FAQHubQuestionForm from 'containers/FAQHub/FAQHubQuestionForm';
import KnowledgeHubAccordion from 'containers/KnowledgeHub/KnowledgeHubAccordion';
import Head from 'next/head';
import Script from 'next/script';

function KnowledgeHubPage({ content }) {
  const { isFallback } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  if (!content) {
    return <Error code={404} />;
  }

  const {
    og_description: ogDescription,
    og_image: ogImage,
    seo_title: seoTitle,
    seo_description: seoDescription,
  } = content;

  const topics = content.body;
  const [allQuestions, setAllQuestions] = useState([]);
  const [filteredFaqItems, setFilteredFaqItems] = useState(null);
  const getAllQuestions = () => {
    const faqTopics = content.body;
    let faqItemsArray = [];
    faqTopics.map((topic) => {
      topic.items.map((item) =>
        faqItemsArray.push({ ...item, topicName: topic.primary.topic_name }),
      );
    });
    return faqItemsArray;
  };
  useEffect(() => {
    setAllQuestions(getAllQuestions());
  }, []);
  const onSearch = (searchInput) => {
    if (searchInput === '') {
      setFilteredFaqItems(null);
      return;
    }
    const input = searchInput.toLowerCase();
    const results = allQuestions.filter((item) => {
      const question = item.question;
      const topic = item.topicName;
      if (
        question.toLowerCase().includes(input) ||
        topic.toLowerCase().includes(input)
      ) {
        return item;
      }
    });
    setFilteredFaqItems(results);
  };
  return content ? (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:description" content={ogDescription} />
        <meta
          property="og:image"
          content={
            ogImage?.url
              ? ogImage?.url
              : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
          }
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1024" />
      </Head>
      <Script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID}');`,
        }}
        strategy="lazyOnload"
      />
      <FAQHubBanner
        title={'How can we help you?'}
        onSearch={(val) => onSearch(val)}
      />
      {filteredFaqItems && (
        <div className="results_container">
          <div className="results_wrapper">
            <button
              className="close_button"
              onClick={() => setFilteredFaqItems(null)}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="jsx-2179674081"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                  fill="#E4E4E4"
                  class="jsx-2179674081"
                ></path>
              </svg>
            </button>

            {filteredFaqItems?.length > 0 ? (
              <div>
                <div>Results Found: {filteredFaqItems?.length}</div>
                {filteredFaqItems?.map((item, idx) => (
                  <div key={idx}>
                    <div className="result_topic_name">{item.topicName}</div>
                    <KnowledgeHubAccordion
                      title={item.question}
                      content={item.answer}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <p>No results found</p>
            )}
          </div>
        </div>
      )}
      <FAQHubNavigation data={topics} />
      <div className="container">
        <div id="featured">
          {topics.map((topic, idx) => {
            const topicTitle = topic.primary.topic_name;
            const topicFaqItems = topic.items;
            return (
              <div id={`faqTopic-${idx}`}>
                <KnowledgeHubFAQs
                  title={topicTitle}
                  data={topicFaqItems}
                  key={idx}
                />
              </div>
            );
          })}
        </div>
        <div id="submit_question" className="question_form_container">
          <FAQHubQuestionForm />
        </div>
      </div>
      <style jsx>{`
        .close_button {
          background: none;
          position: absolute;
          top: 48px;
          right: 48px;
          border: none;
        }
        .result_topic_name {
          font-family: 'big_noodle_titling';
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          padding-top: 20px;
        }
        .results_wrapper {
          max-width: 1440px;
          padding: 48px;
          margin: 0 auto;
          position: relative;
        }
        .question_form_container {
          max-width: 640px;
          margin: 116px auto 192px auto;
        }
        .container {
          max-width: 1440px;
          margin: 0 auto;
          padding: 8px 48px;
        }

        @media (max-width: 991px) {
          .container {
            padding: 0 16px;
          }
        }
      `}</style>
    </>
  ) : (
    <div>Data not found</div>
  );
}

export async function getStaticProps({ preview = false, previewData }) {
  const {
    props: { global },
  } = await globalProps();

  const { ref } = previewData || {};

  const page = await getDocumentByUid('landing-page', 'faq-hub', ref);

  const pageContent = page.data;

  return {
    props: {
      global,
      content: pageContent,
      preview,
    },
    revalidate: 3600,
  };
}

export default KnowledgeHubPage;
